module.exports = __webpack_public_path__ + "static/img/loginLogo.2b876e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/loginLogo.png
// module id = PxwL
// module chunks = 26